import { _t, findParameter } from '../base.js'

export function initDetail() {
    addRedirectUrl()
    quantityDiscounts()
    detailTextChanges()

    // Fixed CTA bar
    floatingProduct()
    document.addEventListener('scroll', floatingProductInfoObserver)
}
function detailTextChanges() {
    $('.detail-parameters .delivery-time span').text(_t('deliveryTime'))
}
function quantityDiscounts() {
    const productCode = getShoptetDataLayer('product').code

    // Ristre 200g
    if (productCode === '004') {
        $('.quantity-discounts__item[data-amount="1"] .quantity-discounts__title').text(
            _t('quantityDiscounts.ristre200g.12')
        )
        $('.quantity-discounts__item[data-amount="36"] .quantity-discounts__title').text(
            _t('quantityDiscounts.ristre200g.36')
        )
    }
    // Ristre 500g
    if (productCode === '011') {
        $('.quantity-discounts__item[data-amount="1"] .quantity-discounts__title').text(
            _t('quantityDiscounts.ristre500g.6')
        )
        $('.quantity-discounts__item[data-amount="18"] .quantity-discounts__title').text(
            _t('quantityDiscounts.ristre500g.18')
        )
    }

    // Update price based on quantity
    $('.p-data-wrapper .add-to-cart .quantity').on('change', function () {
        // 1.12 = 12% VAT
        const vat = 1.12
        const currentPrice = $('.quantity-discounts__item--highlighted .quantity-discounts__price').text()
        const priceNumber = parseFloat(currentPrice.replace(/[^0-9,]/g, '').replace(',', '.'))
        const priceWithoutVat = (priceNumber / vat).ShoptetFormatAsCurrency()

        // Price with VAT
        $('.p-data-wrapper .p-final-price-wrapper .price-final-holder')
            .contents()
            .first()
            .replaceWith(` ${currentPrice} `)

        // Price without VAT
        $('.p-data-wrapper .price-additional').text(`${priceWithoutVat} ${_t('priceWithoutVat')}`)
    })
}

function addRedirectUrl() {
    const redirectUrl = findParameter('redirectUrl')
    const minOrderQuantity = Number($('.p-to-cart-block .quantity .amount').val())
    const [otherProductBtn, otherProductUrl] = findParameter('otherProduct').split(';')

    if (redirectUrl?.length > 0 && minOrderQuantity !== 1) {
        $('.p-to-cart-block').after(/* HTML */ `
            <div class="redirect-url-wrapper">
                <div class="redirect-url__content">
                    <span>${_t('minOrderQuantity')}: ${minOrderQuantity} ${_t('pieces')}.</span>
                    <span class="redirect-url-wrapper__text">
                        ${_t('forPurchase')}
                        <a href="${redirectUrl}" target="_blank" class="redirect-url">
                            <span>${_t('buyOn')}</span>
                        </a>
                    </span>
                </div>
                <div class="redirect-other-product">
                    <a href="${otherProductUrl}" target="_blank" class="btn btn-primary"
                        >${otherProductBtn}</a
                    >
                </div>
            </div>
        `)
    }
}
const createFloatingProductHTML = () => {
    const imageSrc = document.querySelector('.p-image img')?.src
    const productName = document.querySelector('.p-detail-inner-header h1')?.textContent

    // Get add-to-cart wrapper from the original form
    const originalForm = document.querySelector('#product-detail-form')
    const addToCartWrapper = originalForm?.querySelector('.p-add-to-cart-wrapper') || null

    // Get add-to-cart HTML
    const addToCartHTML = addToCartWrapper ? addToCartWrapper.outerHTML : ''

    return /* HTML */ `
        <div class="fixed-product-info">
            <div class="container">
                <div class="fixed-product-info__top">
                    <div class="fixed-product-info__top--name">
                        <img src="${imageSrc}" alt="product image" />
                        <h3 class="product-name">${productName}</h3>
                    </div>
                    <div class="p-to-cart-block">${addToCartHTML}</div>
                </div>
            </div>
        </div>
    `
}

const floatingProduct = () => {
    const pDetail = document.querySelector('.p-detail')

    pDetail.insertAdjacentHTML('beforeend', createFloatingProductHTML())

    setTimeout(() => {
        const variantNotChosen = $('.disabled-add-to-cart')

        if (variantNotChosen.length) {
            $('.fixed-product-info .btn').click(function (e) {
                e.preventDefault()
                $('.add-to-cart .add-to-cart-button').click()
            })
        }
    }, 100)
}

const floatingProductInfoObserver = () => {
    let scrollPos = window.scrollY
    const tabsPos = $('.p-detail-tabs-wrapper').offset().top
    const cartButton = $('.p-to-cart-block .add-to-cart-button')

    if (!cartButton.length) return

    const cartBtnHeight = cartButton.height()
    const cartBtnPos = cartButton.offset().top + cartBtnHeight
    const body = document.body
    const targetPos = cartBtnPos

    if (scrollPos >= targetPos) {
        body.classList.add('floating-product-info')
        body.classList.remove('login-window-visible')
    } else {
        body.classList.remove('floating-product-info')
    }
}
